export const parseBridgeLevelLabels = (levelLabels) => {
  if (!levelLabels) {
    return null;
  }

  if (typeof levelLabels === "string") {
    try {
      return JSON.parse(levelLabels);
    } catch (error) {
      console.warn("Failed to parse bridge level labels:", error);
      return null;
    }
  }

  return levelLabels;
};

const pluralizeLastWord = (word, count) => {
  if (count === 1) {
    return word;
  }

  if (/[^aeiou]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }

  if (/(s|x|z|ch|sh)$/i.test(word)) {
    return `${word}es`;
  }

  return `${word}s`;
};

export const pluralizeBridgeLevelLabel = (label, count = 2) => {
  const normalizedLabel = String(label || "").trim();

  if (!normalizedLabel) {
    return count === 1 ? "Element" : "Elements";
  }

  if (count === 1) {
    return normalizedLabel;
  }

  const words = normalizedLabel.split(/\s+/);
  const lastWord = words.pop();

  return [...words, pluralizeLastWord(lastWord, count)].join(" ");
};

export const getAreaDataLevelLabel = (
  levelLabels,
  fallbackLabel = "Element",
) => {
  const parsedLevelLabels = parseBridgeLevelLabels(levelLabels);

  if (!parsedLevelLabels || typeof parsedLevelLabels !== "object") {
    return fallbackLabel;
  }

  for (let level = 1; level <= 8; level += 1) {
    const levelConfig = parsedLevelLabels[`level${level}`];
    if (levelConfig?.holdsAreaData) {
      return levelConfig.label || fallbackLabel;
    }
  }

  return fallbackLabel;
};

export const getBridgeLevelLabel = (
  levelLabels,
  level,
  fallbackLabel = "Element",
) => {
  const parsedLevelLabels = parseBridgeLevelLabels(levelLabels);
  const normalizedLevel = Number(level);

  if (
    !parsedLevelLabels ||
    typeof parsedLevelLabels !== "object" ||
    !Number.isInteger(normalizedLevel) ||
    normalizedLevel <= 0
  ) {
    return fallbackLabel;
  }

  return parsedLevelLabels[`level${normalizedLevel}`]?.label || fallbackLabel;
};

export const getBridgeLevelLabels = (
  levelLabels,
  level,
  fallbackLabel = "Element",
) => {
  const singular = getBridgeLevelLabel(levelLabels, level, fallbackLabel);

  return {
    singular,
    plural: pluralizeBridgeLevelLabel(singular, 2),
  };
};

export const getAreaDataLevelLabels = (
  levelLabels,
  fallbackLabel = "Element",
) => {
  const singular = getAreaDataLevelLabel(levelLabels, fallbackLabel);

  return {
    singular,
    plural: pluralizeBridgeLevelLabel(singular, 2),
  };
};
